import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../openapi';

@Pipe({
  name: 'graveNumberPlaceholder',
  standalone: true
})
export class GraveNumberPlaceholderPipe implements PipeTransform {

  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (application?.service?.url) {
      case '/wniosek-o-dzierzawe-miejsca-grzebalnego': {
        return 'Wpisz tu numer miejsca';
      }
      default: {
        return 'Wpisz tu numer grobu';
      }
    }
  }

}
